import { Product } from '@/types';

/** 商品是否不可购买（置灰）：接口 is_gray 或已达限购次数 */
export function isProductPurchaseDisabled(product: Product): boolean {
  if (product.is_gray === 1) return true;
  if (product.stock === 0) return true;

  const purchaseLimit = product.purchase_limit ?? 0;
  if (purchaseLimit <= 0) return false;

  const purchaseUsed = product.purchase_used ?? 0;
  return purchaseUsed >= purchaseLimit;
}

/** 当前可购买的最大数量（含限购与库存） */
export function getProductMaxPurchasableQuantity(product: Product): number {
  if (isProductPurchaseDisabled(product)) return 0;

  const stockLimit = product.stock ?? 999;
  const purchaseLimit = product.purchase_limit ?? 0;
  const purchaseUsed = product.purchase_used ?? 0;
  const remainingPurchaseLimit =
    purchaseLimit > 0 ? Math.max(purchaseLimit - purchaseUsed, 0) : undefined;

  return Math.min(stockLimit, remainingPurchaseLimit ?? stockLimit);
}
